import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData } from '@components/ssap/SsapTypes';

interface IOutsideParentAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    formName: string,
    isAsteriskShown: boolean
}

const OutsideParentAttestation = (props: IOutsideParentAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            taxHousehold: {
                medicaidConsent
            }
        },
        formName,
        isAsteriskShown = true
    } = props;

    const className = classNames({
        'required-true': isAsteriskShown
    });

    return (
        <UniversalInput
            label = { {
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: (
                        <span className = { className } >
                            <FormattedMessage id = 'ssap.input.label.acknowledge_outside_parent' />
                        </span>
                    )
                }
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.CHECKBOX,
                name: 'medicaidConsent',
                classes: [ 'disp-styl' ],
                checked: medicaidConsent,
                value: medicaidConsent,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'taxHousehold' ]
            } }
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default OutsideParentAttestation;